import * as rt from 'runtypes';
export * as accountingSystemUtils from './accounting-system-utils';
export { encryptPinReadData, getPIN, yearAndMonthToExpiryDate } from './pin';
export { compareOrgInfo, getOrgTypeFromBrregResponse, isSupportedOrgType } from './orgs';
export * as dateFnsExtras from './date-fns-extras';
export * as autofillConstants from './autofill-constants';
export * as runtypesUtils from './runtypes';
export * as promotions from './promotion';
export * as categoryUtils from './category-utils';
export * from './pages';
export * from './ledger-icons';
export const bankIdSessionStateRt = rt.Union(rt.Literal('success'), rt.Literal('abort'), rt.Literal('aborted'), rt.Literal('error'));

// The query param name for continue URLs, i.e. ?fortsett=https://...
// This is used to to redirect a user to a URL after they log in.
export const continueUrlParam = 'fortsett';
const numberToSpelledOutNumber = ['null', 'ett', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti'
// end here, 'elleve' is too long
];

export function getNumberAsNorwegian(num) {
  return numberToSpelledOutNumber[num] ?? num.toString();
}

// Test APIs are commented out for now as we don't actually use them, not even in dev
export const validBankIdIframeOrigins = new Set(['https://id.idfy.io',
// 'https://id2-test.idfy.io',
// these are legacy, but their docs recommends keeping them around until they completely finish migration
'https://id.signicat.io',
// 'https://id-test.signicat.io',
// this is the current v1 API - we should remove it at some point
'https://id.signere.no']);
export const validAgentTypesForOnboarding = new Set(['Administrator', 'CFO', 'AccountantManager', 'Observer', 'Employee']);
export function calculateCrossborderPaymentFee(iban, currencyCode, currencyAmount) {
  const hasLowFee = (currencyCode === 'EUR' && currencyAmount <= 50_000 || currencyCode === 'SEK' && currencyAmount <= 500_000) && iban.trim().slice(0, 2) !== 'NO';
  if (hasLowFee) {
    return 35;
  } else {
    return 60;
  }
}

// This is here so we get type errors if we omit an avatar that is defined in
// the graphql schema. The alternative would be to use an enum, but that would
// be a change to all generated code.
const avatarIds = {
  Barry1Avatar: '',
  Barry2Avatar: '',
  Barry3Avatar: '',
  Barry4Avatar: '',
  Bloomberg1Avatar: '',
  Bloomberg2Avatar: '',
  Bloomberg3Avatar: '',
  Bloomberg4Avatar: '',
  Balloon1Avatar: '',
  Balloon2Avatar: '',
  Balloon3Avatar: '',
  Balloon4Avatar: '',
  Puss1Avatar: '',
  Puss2Avatar: '',
  Puss3Avatar: '',
  Puss4Avatar: '',
  Simpleton1Avatar: '',
  Simpleton2Avatar: '',
  Simpleton3Avatar: '',
  Simpleton4Avatar: '',
  Bulby1Avatar: '',
  Bulby2Avatar: '',
  Bulby3Avatar: '',
  Bulby4Avatar: '',
  Whiz1Avatar: '',
  Whiz2Avatar: '',
  Whiz3Avatar: '',
  Whiz4Avatar: '',
  Fruity1Avatar: '',
  Fruity2Avatar: '',
  Fruity3Avatar: '',
  Fruity4Avatar: ''
};
export const availableAvatars = Object.keys(avatarIds);
export const supportedCurrencies = ['AUD', 'CAD', 'CHF', 'DKK', 'EUR', 'GBP', 'HKD', 'JPY', 'NZD', 'PLN', 'SEK', 'SGD', 'THB', 'USD', 'ZAR'];
//# sourceMappingURL=index.js.map